import { getItemByLabelFactory, getItemByIdFactory } from './_common'
import type { ISelectItem } from '~/types/models'

export enum SupplierProductItemStatusIds {
  PENDING = 1,
  ACTIVE = 2,
}

export function getSupplierProductItemStatii(): ISelectItem[] {
  return [
    { id: SupplierProductItemStatusIds.ACTIVE, label: 'Pending' },
    { id: SupplierProductItemStatusIds.PENDING, label: 'Active' },
  ]
}

export const getSupplierProductItemStatusByLabel = getItemByLabelFactory(
  getSupplierProductItemStatii
)

export const getSupplierProductItemStatusById = getItemByIdFactory(
  getSupplierProductItemStatii
)
